/* Hudson gallery: real variant photography + live, accessible product details. */
(function (global) {
  'use strict';
  const kinds = ['benefits', 'details', 'sizing', 'sofa', 'bedroom'];
  const titles = { benefits: 'Memories worth framing.', details: 'Details that matter.', sizing: 'One frame. Two looks.' };
  const labels = { benefits: 'Benefits', details: 'Details', sizing: 'Sizing', sofa: 'Living room', bedroom: 'Bedroom' };
  function size(value) { return String(value || '').replace(/\s*[x\u00d7]\s*/gi, ' \u00d7 '); }
  function model(variant, spec) {
    const d = spec || {};
    const construction = String(d.constr || '');
    const glazing = /plexiglass/i.test(construction) ? 'Plexiglass glazing' : /glass/i.test(construction) ? 'Shatter-resistant glass' : 'Shatter-resistant glazing';
    return { id: String(variant.id), sku: variant.sku, image: variant.featured_image && variant.featured_image.src,
      color: d.color || variant.option2 || variant.options[1], frame: size(d.frame || d.size || variant.option1 || variant.options[0]),
      print: size(d.print || d.mat || variant.option3 || variant.options[2]), opening: d.mo ? size(d.mo) : '',
      material: /engineered/i.test(d.material || '') ? 'Engineered wood molding' : (d.material || 'Frame molding'),
      glazing, dims: d.dims || '', matted: d.fitst !== 'unmatted' && !!(d.print || d.mat || variant.option3) };
  }
  function el(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function url(src, width) { const u = new URL(src, global.location.href); u.searchParams.set('width', String(width)); return u.href; }
  function init(root, product, specs) {
    const configEl = root.querySelector('[data-af-hudson-gallery-config]');
    if (!configEl) return null;
    let config; try { config = JSON.parse(configEl.textContent); } catch (_) { return null; }
    const box = root.querySelector('[data-af-main-image]');
    const strip = root.querySelector('[data-af-thumbs]');
    const hero = root.querySelector('[data-af-hudson-hero]');
    if (!box || !strip || !hero) return null;
    let current, active = 'hero';
    function photo(m, miniature) {
      const wrap = el('div', 'hg-cutout');
      const audit = config.photos[m.sku];
      const image = el('img'); image.src = url(m.image, miniature ? 160 : 1200);
      image.alt = m.color + ' Hudson frame, ' + m.frame + ', matted to ' + m.print;
      image.decoding = 'async';
      if (audit) {
        const [x,y,w,h] = audit;
        wrap.style.aspectRatio = String(w / h);
        image.style.width = (100 / w) + '%'; image.style.height = (100 / h) + '%';
        image.style.left = (-100 * x / w) + '%'; image.style.top = (-100 * y / h) + '%';
      }
      wrap.append(image); return wrap;
    }
    function card(kind, m, miniature) {
      const node = el('div', 'hg-card hg-' + kind);
      node.dataset.hgVariant = m.id;
      if (kind === 'sofa' || kind === 'bedroom') {
        // Preserve the original editorial photographs, without variant overlays.
        const scene = el('img', 'hg-scene');
        scene.src = url(config.rooms[kind], miniature ? 160 : 1600);
        scene.alt = config.roomAlts[kind];
        scene.decoding = 'async';
        node.append(scene);
        return node;
      }
      const title = el('h3', 'hg-title', titles[kind]); node.append(title);
      const content = el('div', 'hg-content');
      const copy = el('div', 'hg-copy');
      if (kind === 'benefits') {
        ['Gallery-style white mat', 'Wide woodgrain molding', 'Hangers already attached'].forEach(t => copy.append(el('p','hg-benefit',t)));
      } else if (kind === 'details') {
        [m.material, m.matted ? 'White mat included' : 'Unmatted display', m.glazing].forEach(t => copy.append(el('p','hg-benefit',t)));
      } else {
        const mat = el('div','hg-fit'); mat.append(el('span','hg-fit-label', m.matted ? 'With mat' : 'Print size'),el('strong','hg-fit-size',m.matted ? m.print : m.frame),el('span','hg-fit-unit','inch print'));
        copy.append(mat);
        if (m.matted) { const full = el('div','hg-fit'); full.append(el('span','hg-fit-label','Without mat'),el('strong','hg-fit-size',m.frame),el('span','hg-fit-unit','inch print')); copy.append(full); }
      }
      const picture = el('div','hg-picture');
      const cutout = photo(m,miniature);
      const bounds = config.photos[m.sku];
      if (bounds) cutout.style.width = Math.min(100, 62 * (bounds[2] / bounds[3]) / 47.7 * 100) + '%';
      picture.append(cutout);
      content.append(copy,picture); node.append(content);
      const footer = el('div','hg-footer');
      if (kind === 'sizing' && m.opening) footer.append(el('p','hg-opening','Mat opening: ' + m.opening));
      footer.append(el('p','hg-finish',m.color + ' \u00b7 ' + m.frame + ' in'));
      node.append(footer); return node;
    }
    function show(kind) {
      if (!current) return;
      active = kind;
      box.classList.remove('is-primary');
      if (kind === 'hero') {
        const image = el('img'); image.src=url(current.image,1200); image.alt=current.color+' Hudson frame, '+current.frame;
        box.replaceChildren(image);
      } else box.replaceChildren(card(kind,current,false));
      strip.querySelectorAll('[data-af-thumb-index]').forEach(t => {
        const selected = kind === 'hero' ? t === hero : t.dataset.afHudsonCard === kind;
        t.classList.toggle('active',selected); t.setAttribute('aria-pressed',String(selected));
      });
    }
    // Capture only Hudson cards/hero so the generic gallery handler cannot replace them.
    strip.addEventListener('click', event => {
      const thumb = event.target.closest('[data-af-thumb-index]');
      if (!thumb || !strip.contains(thumb)) return;
      if (thumb === hero || thumb.dataset.afHudsonCard) {
        event.stopImmediatePropagation(); show(thumb === hero ? 'hero' : thumb.dataset.afHudsonCard);
      }
    }, true);
    return { update(variant) {
      const m = model(variant,specs && specs[variant.id]);
      if (!m.image) return; // Never show a different variant's photo as a fallback.
      current = m;
      hero.dataset.afThumbImageId=String(variant.featured_image.id || '');
      hero.dataset.afThumbSrc=url(m.image,1200); hero.dataset.afThumbAlt=m.color+' Hudson frame, '+m.frame;
      const ti=hero.querySelector('img'); ti.removeAttribute('srcset'); ti.src=url(m.image,160); ti.alt=hero.dataset.afThumbAlt;
      kinds.forEach(kind=>{
        const t=strip.querySelector('[data-af-hudson-card="'+kind+'"]');
        if (!t) return;
        t.hidden=false;
        t.setAttribute('aria-label', config.roomAlts && config.roomAlts[kind] || labels[kind]+' \u2014 '+m.color+' Hudson '+m.frame);
        const preview=card(kind,m,true); preview.setAttribute('aria-hidden','true');
        t.replaceChildren(preview,el('span','hg-thumb-label',labels[kind]));
      });
      show(active); // Keep the shopper on their chosen card while updating its variant.
    } };
  }
  global.AFHudsonGallery = { init, model };
})(window);
